<template>
  <px-autocomplete-comprador-multiple
    dense
    required
    class="rounded-tag-small required"
    @blur="onBlur"
    v-bind="$attrs"
    v-model="localValue"/>
</template>

<script>
export default {
  props: {
    value: Array,
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    onBlur(event) {
      this.$emit('blur', event);
    },
  },
};
</script>
